var gql = require("@apollo/client").gql;

const PROVIDERS_WITH_TARIFFS_QUERY = gql`
	query PROVIDERS_WITH_TARIFFS_QUERY(
		$tariffFilter: String
		$providerLimit: Int
		$providerOffset: Int
		$tariffsPerProvider: Int
		$providerJoin: Boolean
		$vipProvider: Boolean
		$firstExclusive: Boolean
		$sort: String
	) {
		providersWithTariffs(
			tariffFilter: $tariffFilter
			providerLimit: $providerLimit
			providerOffset: $providerOffset
			tariffsPerProvider: $tariffsPerProvider
			providerJoin: $providerJoin
			vipProvider: $vipProvider
			firstExclusive: $firstExclusive
			sort: $sort
		) {
			pagination {
				items_count
				items_total
			}
			providerIds
			data {
				id
				name
				mobile_new {
					internet
					calls
					sms
					internet_type
					calls_type
					sms_type
				}
				provider {
					id
					name
					logo
					logo_2
					url_name
					vip_provider
					reviews_info {
						count_total
					}
					sell_self {
						provider {
							name
						}
					}
					rating {
						expert {
							final
						}
					}
					contacts {
						phones
						link
						card
					}
					region {
						url
					}
					info {
						cnt_tariffs
						min_price
						max_speed
					}
					provider_settings {
						tariffs {
							value
							button_text
						}
					}
				}
				is_exclusive
				after {
					rule {
						code
						value
						month_cnt
						date_end
					}
					change {
						code
						name
						id
					}
					data {
						price {
							license_fee
							license_fee_month
						}
						internet {
							type {
								id
								name
							}
							speed_in
							include_trafic_metrics {
								id
								name
							}
							include_trafic_interval {
								id
								name
							}
							include_trafic_value
							excess_speed_in
							excess_speed_out
						}
					}
				}
				price {
					license_fee
					license_fee_month
					system_calculation_connect
					license_fee_interval {
						code
						name
						name_short
					}
				}
				displayPrice
				connection {
					price
					time
				}
				internet {
					icon
					type {
						id
						name
					}
					speed_in
					include_trafic_metrics {
						id
						name
					}
					include_trafic_interval {
						id
						name
					}
					include_trafic_value
					excess_speed_in
					excess_speed_out
				}
				tv {
					channels
					channels_hd
					use_text
				}
				dody {
					image_24px
					name
					short_description
					comment_tariff
					state
				}
				region {
					id
					url
				}
				social_unlim {
					whatsapp
					telegram
					viber
					discord
					skype
					vk
					ok
					tiktok
					youtube
					snapchat
				}
			}
		}
	}
`;

export default PROVIDERS_WITH_TARIFFS_QUERY;
